module.exports = __webpack_public_path__ + "static/media/sem-senhas.527f643a.svg";